import React from "react";
import { setSegmentation } from './../Core/Segment';
import searchBox from '../Components/searchBox.jsx';
import CheckoutHeader from './../Components/CheckoutHeader.jsx';
import HomeRouter from '../Router/HomeRouter';
import LoginHeader from './../Components/LoginHeader.jsx';
import AddToCartModal from './../Components/AddToCartModal.jsx';
import AddToCart from './../Components/AddToCart.jsx';
import CartHeader from './../Components/CartHeader.jsx';
import LeafletBox from './../Components/LeafletBox.jsx';
import VisitedProducts from './../Components/VisitedProducts.jsx';
